function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "telephone"
}, /*#__PURE__*/React.createElement("path", {
  d: "m21.479 16.663-3.535-3.535c-.375-.375-1.039-.375-1.414 0l-1.061 1.061c-.054.053-.164.059-.21.059-.212 0-.548-.108-.852-.412l-4.241-4.242c-.433-.433-.476-.942-.354-1.063l1.061-1.061c.188-.188.293-.441.293-.707s-.105-.52-.293-.707l-3.537-3.535c-.391-.391-1.023-.391-1.414 0l-2.475 2.475c-1.754 1.755-1.596 4.769.354 6.718l8.485 8.485c.999.999 2.342 1.571 3.684 1.571 1.171 0 2.248-.433 3.034-1.218l2.475-2.476c.39-.389.39-1.022 0-1.413zm-3.889 2.476c-.931.93-2.772.763-3.89-.354l-8.485-8.485c-1.169-1.17-1.328-2.914-.354-3.89l1.768-1.768 2.122 2.121-.354.354c-.975.975-.815 2.719.354 3.89l4.242 4.242c1.133 1.134 2.944 1.3 3.89.354l.354-.354 2.121 2.121z"
}));

var Svg118Telephone = function Svg118Telephone(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 512,
    viewBox: "0 0 24 24",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(Svg118Telephone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/118-telephone.d79898e4.svg";
export { ForwardRef as ReactComponent };